<div class="cockpit-content">
  <app-chart-download-button (buttonClick)="exportCurrentCodes()">
      <h2 class="title">
          {{'m1.cockpit-kontrolle.card.currentCodes.content.1' | translate}}
      </h2>
  </app-chart-download-button>
  <app-current-codes-table [data]="data" [funktionen]="funktionen" ></app-current-codes-table>
</div>
